import ApprovedApplications from "../Administration/ApprovedApplications";

const PwdApprovedApplication = ({ role }) => {
  return (
    <>
      <ApprovedApplications role={role} />
    </>
  );
};

export default PwdApprovedApplication;
